import { convertToNumber, isValidNumber } from "../isValidNumber";

/**
     * Calcula el interes corriente de un crédito
     * @param {number} requestedAmount Monto solicitado ej. 200000
     * @param {number} termInDays plazo en días ej. 15
     * @param {number} tasaInteresCorriente tasa de interes corriente ej. 10
*/

export const calcInteresCorrienteV2 = (requestedAmount, termInDays, tasaInteresCorriente) => {

    if (!isValidNumber(requestedAmount)) throw new Error("El campo requestedAmount no es un número válido.");
    if (!isValidNumber(termInDays)) throw new Error("El campo termInDays no es un número válido.");

    let tasaInteresCorrienteParseado = convertToNumber(tasaInteresCorriente);

    if (!isValidNumber(tasaInteresCorrienteParseado)) {
        const cached = localStorage.getItem("currentInterestRate");
        tasaInteresCorrienteParseado = cached ? convertToNumber(cached) : null;
    }

    if (!isValidNumber(tasaInteresCorrienteParseado)) {
        throw new Error("No se encontró una tasa de interés corriente válida.");
    };

    let interesCorriente = requestedAmount * (tasaInteresCorrienteParseado / 100) * termInDays;

    if (!isValidNumber(interesCorriente)) {
        throw new Error("El resultado de la operación dió como resultado un número no válido.");
    }
    return Math.round(interesCorriente);
}


export const convertPercentageToDecimal = (percentageString) => {
    if (!percentageString) return null;
    const cleanedPercentage = percentageString.replace(',', '.');
    const percentage = parseFloat(cleanedPercentage);

    if (isNaN(percentage) || !isFinite(percentage)) {
        return null;
    }
    return percentage / 100;
}

/* Elevar a la potencia  */
export const raiseToPower = (decimalValue, exponent) => {
    return Math.pow(decimalValue, exponent);
}


/* Calcula la tasa de usura efectiva mensual */
export const calcularInteresCorrienteTem = (_interesCorrienteTea) => {
    let interesCorrienteTea = Number(_interesCorrienteTea).toFixed(2);
    let interesCorrienteTeaDecimal = convertPercentageToDecimal(interesCorrienteTea);
    let interesCorrienteTem = interesCorrienteTeaDecimal + 1;
    interesCorrienteTem = raiseToPower(interesCorrienteTem, 1 / 12);
    interesCorrienteTem = interesCorrienteTem - 1;
    interesCorrienteTem = interesCorrienteTem * 100;

    if (isNaN(interesCorrienteTem) || !isFinite(interesCorrienteTem)) {
        return null;
    }
    return interesCorrienteTem;
}


/* Calcula la tasa de usura efectiva diaria */
export const calcularInteresCorrienteTed = (interesCorrienteTem) => {
    let interesCorrienteTed = interesCorrienteTem / 30;
    if (isNaN(interesCorrienteTed) || !isFinite(interesCorrienteTed)) {
        return null;
    }
    return interesCorrienteTed.toFixed(5);
}
